import { ApprovalEmptyStateI18nTitle } from '../i18n/ApprovalEmptyStateI18n';
import { H4 } from 'foundations-components/transitional/components/H4';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalEmptyStateQuote() {
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    padding: "500",
    blockSize: "100%",
    "data-test-id": "product-approvals-approval-sidebar-empty-state-quote",
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      type: "notFound",
      illustration: "all-conversations-complete",
      illustrationProps: {
        width: 150
      },
      title: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(ApprovalEmptyStateI18nTitle, {})
      })
    })
  });
}
export default ApprovalEmptyStateQuote;